import axios from "axios";
import { constants } from "../constants";



export const refreshToken =  (status) => {
  return new Promise(async(resolve, reject) => {
      console.log('llamando refresh con status... ' + status)
      const URL = constants.test_host + '/auth/refresh-token'
      const token = window.localStorage.getItem('at');
      await axios.get(URL, {headers:{ 'authorization': `Bearer ${token}` , 'Content-Type': 'application/json', 'Access-Control-Allow-Credentials': true}, withCredentials: true})
      .then(({data})=> {
        window.localStorage.removeItem('at')
        window.localStorage.setItem('at', data.access_token)
        console.log('token refrescado...')
        resolve(data.result)
      })
      .catch(error => {
        console.log(error)
        window.localStorage.clear();
        resolve(false)
      })

  })
}

export const validToken = () => {
  return new Promise(async(resolve, reject) => {
  
    console.log('llamando validToken')
      const token = window.localStorage.getItem('at');
      const URL_VALID_TOKEN = constants.test_host + '/auth/valid-token'
      await axios.get(URL_VALID_TOKEN, {headers:{ 'authorization': `Bearer ${token}` , 'Content-Type': 'application/json', 'Access-Control-Allow-Credentials': true}, withCredentials: true})
      .then(({data}) => {
        console.log(data.statusCode)
        resolve(data.statusCode)
      })
      .catch(error => {
        console.log(error)
        resolve(error.response.data.statusCode)
      })

  })
}
export const init = async(from) => {
    console.log('llamando init...')
    const status = await validToken()
    console.log('status ' + status);
    if(status===200) return true
    const resp = await refreshToken(status);
    console.log('resp token...' + resp)
    if(resp){
      console.log('Token refrescado DESDE...' + from)
      return true;
    }else{
          console.log('No se pudo refrescar token desde...' + from);
          window.localStorage.clear();
          return false;
      
      }
  }